import { createContext, useContext, useState, useEffect } from "react";

const DICT = {
  en: {
    appName: "EduCentre",
    appSubtitle: "Bimbel Management",
    login: "Sign in",
    email: "Email",
    password: "Password",
    signIn: "Sign In",
    signingIn: "Signing in…",
    welcomeBack: "Welcome back",
    loginSubtitle: "Manage your tuition centre with clarity. Sign in to continue.",
    logout: "Logout",
    dashboard: "Dashboard",
    students: "Students",
    educators: "Educators",
    parents: "Parents",
    classes: "Classes",
    schedule: "Schedule",
    enrollment: "Enrollment",
    attendance: "Attendance",
    markAttendance: "Mark Attendance",
    grades: "Grades",
    enterGrades: "Enter Grades",
    results: "Results",
    materials: "Materials",
    invoices: "Invoices",
    fees: "Fees & Payments",
    announcements: "Announcements",
    reports: "Reports",
    settings: "Settings",
    myDashboard: "My Dashboard",
    myClasses: "My Classes",
    mySchedule: "My Schedule",
    myResults: "My Results",
    myFees: "My Fees",
    myChildren: "My Children",
    overview: "Overview",
    people: "People",
    academics: "Academics",
    finance: "Finance",
    system: "System",
    addStudent: "Add Student",
    addEducator: "Add Educator",
    addClass: "Add Class",
    save: "Save",
    cancel: "Cancel",
    back: "Back",
    next: "Next",
    confirm: "Confirm",
    search: "Search",
    activeStudents: "Active Students",
    activeClasses: "Active Classes",
    activeEducators: "Active Educators",
    revenueThisMonth: "Revenue This Month",
    outstandingFees: "Outstanding Fees",
    overdueInvoices: "Overdue Invoices",
    todaysClasses: "Today's Classes",
    pendingTasks: "Pending Tasks",
    attendanceRate: "Attendance Rate",
    role_admin: "Management",
    role_educator: "Educator",
    role_student: "Student",
    role_parent: "Parent",
    name: "Name",
    code: "Code",
    actions: "Actions",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    statusPaid: "Paid",
    statusUnpaid: "Unpaid",
    statusOverdue: "Overdue",
    statusPartial: "Partial",
    statusPresent: "Present",
    statusLate: "Late",
    statusAbsent: "Absent",
    statusExcused: "Excused",
    payNow: "Mark Paid",
    invoice: "Invoice",
    amount: "Amount",
    dueDate: "Due Date",
    description: "Description",
    student: "Student",
    educator: "Educator",
    subject: "Subject",
    level: "Level",
    room: "Room",
    capacity: "Capacity",
    fee: "Fee",
    schedule_days: "Days",
    time: "Time",
    enrolled: "Enrolled",
    enroll: "Enroll",
    selectStudent: "Select student",
    selectClass: "Select class",
    new: "New",
    title: "Title",
    body: "Body",
    audience: "Audience",
    post: "Post",
    materialTitle: "Material Title",
    materialUrl: "URL / Link",
    upload: "Upload",
    addMaterial: "Add Material",
    assessmentName: "Assessment Name",
    maxScore: "Max Score",
    publish: "Publish",
    unpublished: "Unpublished",
    published: "Published",
    score: "Score",
    remark: "Remark",
    saveAll: "Save All",
    submit: "Submit",
    welcome: "Welcome",
    today: "Today",
    days: { 1: "Mon", 2: "Tue", 3: "Wed", 4: "Thu", 5: "Fri", 6: "Sat", 7: "Sun" },
    daysLong: { 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday", 7: "Sunday" },
    months: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun", 7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec" },
    children: "Children",
    noClasses: "No classes today.",
    noData: "No records yet.",
    emptyHint: "Nothing here yet. New entries will show up here.",
    loadFailed: "We couldn't load this page",
    loadFailedHint: "Check your internet connection, then try again.",
    retry: "Try again",
    edit: "Edit",
    delete: "Delete",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    previous: "Previous",
    showing: "Showing",
    of: "of",
    noResults: "No matches found",
    noResultsHint: "Try a different search or clear the filters.",
    clearFilters: "Clear filters",
    allStatuses: "All statuses",
    saved: "Changes saved",
    removed: "Removed",
    deleteTitle: "Delete this item?",
    deleteHint: "This can't be undone.",
    deactivateTitle: "Deactivate this person?",
    deactivateHint: "They will no longer be able to sign in. Their history stays and you can reactivate them later.",
    importStudents: "Import",
    importTitle: "Import students from a file",
    importHint: "Use a CSV file (in Excel choose Save As → CSV). Required columns: full_name, email. Optional: phone, dob, school_name, school_year.",
    downloadTemplate: "Download template",
    chooseFile: "Choose CSV file",
    importPreview: "rows found",
    importNow: "Import students",
    importDone: "students imported",
    importSkipped: "skipped",
    importDefaultPassword: "New students sign in with the default password student123.",
    notifTitle: "Notifications",
    notifEmpty: "You're all caught up.",
    notifMarkAllRead: "Mark all as read",
    notifOverdue: "Invoice {invoice} for {name} is overdue: {amount} unpaid (due {date}).",
    notifDueSoon: "Invoice {invoice} for {name} is due on {date}: {amount}.",
    notifAbsent: "{name} was absent on {date}.",
    notifClassesToday: "You have {count} class(es) today.",
    sendWhatsapp: "Send WhatsApp reminder",
    waReminder: "Hello, this is a reminder from {centre}: invoice {invoice} for {name} ({amount}) was due on {date}. Please settle it at your earliest convenience. Thank you.",
    printSave: "Print / Save as PDF",
    printInvoice: "Print invoice",
    printReceipt: "Receipt",
    invoiceHeading: "INVOICE",
    receiptHeading: "PAYMENT RECEIPT",
    billedTo: "Billed to",
    amountPaid: "Amount paid",
    balanceDue: "Balance due",
    paidOn: "Paid on",
    paymentHistory: "Payment history",
    thankYou: "Thank you for your payment.",
    printFooter: "This document was generated by EduCentre.",
    reportCard: "Report card",
    reportCardHeading: "STUDENT REPORT CARD",
    attendanceSummary: "Attendance summary",
    averageScore: "Average score",
    generatedOn: "Generated on",
    exportCsv: "Export CSV",
    settingsTitle: "Settings",
    settingsSubtitle: "Your profile, password and centre details",
    profile: "Profile",
    centreDetails: "Centre details",
    centreName: "Centre name",
    centreHint: "Shown on printed invoices, receipts and report cards.",
    address: "Address",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    passwordMismatch: "The two new passwords don't match.",
    passwordChanged: "Password changed",
    profileSaved: "Profile saved",
    uploadFile: "Upload file",
    chooseAFile: "Choose a file (max 5 MB)",
    downloadFile: "Download",
    toastStudentAdded: "Student added",
    toastEducatorAdded: "Educator added",
    toastParentAdded: "Parent added",
    toastClassCreated: "Class created",
    toastAnnouncementPosted: "Announcement posted",
    toastMaterialAdded: "Material added",
    toastInvoiceCreated: "Invoice created",
    toastPaymentRecorded: "Payment recorded",
    toastAttendanceSaved: "Attendance saved",
    toastEnrollmentConfirmed: "Enrollment confirmed",
    toastAssessmentCreated: "Assessment created",
    toastGradesSaved: "Grades saved",
    toastPublished: "Published",
    fieldType: "Type",
    subjectsComma: "Subjects (comma separated)",
    qualifications: "Qualifications",
    occupation: "Occupation",
    colorLabel: "Color",
    startTime: "Start",
    endTime: "End",
    selectPlaceholder: "— Select —",
    nonePlaceholder: "— None —",
    amountIdr: "Amount (IDR)",
    gradeLabel: "Grade",
    assessmentLabel: "Assessment",
    newAssessment: "New Assessment",
    passScore: "Pass Score",
    typeQuiz: "Quiz",
    typeTest: "Test",
    typeAssignment: "Assignment",
    typeProject: "Project",
    audAll: "All",
    audParents: "Parents",
    audStudents: "Students",
    audEducators: "Educators",
    audClass: "Class",
    matLink: "Link",
    matFile: "File",
    matVideo: "Video",
    emp_full_time: "Full time",
    emp_part_time: "Part time",
    emp_freelance: "Freelance",
    emp_contract: "Contract",
    rpTotalStudents: "Total Students",
    rpTotalClasses: "Total Classes",
    rpTotalInvoices: "Total Invoices",
    rpPaidInvoices: "Paid Invoices",
    rpTotalRevenue: "Total Revenue",
    rpClassUtilisation: "Class Utilisation",
    rpInvoiceStatus: "Invoice Status Breakdown",
    rpTopClasses: "Top Classes by Fee",
    rpQuickStats: "Quick Stats",
    rpSubtitle: "Business intelligence & operational metrics",
    unitPosts: "posts",
    unitResources: "resources",
    unitInvoices: "invoices",
    subManage: "Manage assessments and scores",
    subViewResults: "View results",
    subPublished: "Published assessments only",
    subWizard: "4-step wizard",
    openLink: "Open →",
    loadingLabel: "Loading",
    openNav: "Open navigation",
    navMore: "More",
    navMain: "Main navigation",
    closeNav: "Close navigation",
    developedBy: "Developed by",
    refLabel: "Reference",
    themeToggle: "Toggle dark mode",
    themeLight: "Light mode",
    close: "Close",
    skipToContent: "Skip to content",
    newInvoice: "New invoice",
    addParent: "Add parent",
    amountsLocked: "Amounts can't be changed after a payment was recorded.",
    themeDark: "Dark mode",
    fullName: "Full Name",
    phone: "Phone",
    selectRole: "Role",
    invalidLogin: "Invalid email or password",
    monthlyTuition: "Monthly Tuition",
    selectedCourses: "Selected Courses",
    totalPerMonth: "Total Per Month",
    studentInfo: "Student Info",
    selectCourses: "Select Courses",
    feePlan: "Fee Plan",
    confirmStep: "Confirm",
    timetable: "Weekly Timetable",
    weekDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    paymentMethod: "Payment Method",
    cash: "Cash",
    bank: "Bank Transfer",
    qris: "QRIS",
    ewallet: "E-Wallet",
    record: "Record",
    invoiceNumber: "Invoice #",
    billingMonth: "Billing Month",
    yearLevel: "Year Level",
    school: "School",
    dob: "Date of Birth",
    parent: "Parent",
    childrenLinked: "Linked Children",
    rolePill: "Viewing as",
    quickStats: "Quick Stats",
    cmdOpen: "Search or jump to…",
    cmdPlaceholder: "Type a page, action or student name…",
    cmdTitle: "Command palette",
    cmdEmpty: "Nothing found.",
    cmdPages: "Go to page",
    cmdActions: "Quick actions",
    cmdStudents: "Students",
    cmdOpenReport: "Report card",
    cmdSwitchLang: "Switch to Bahasa Indonesia",
    cmdToggleMotion: "Toggle motion (Full / Lite)",
    motionLabel: "Motion",
    motionFull: "Full",
    motionLite: "Lite",
    motionSystemLite: "Lite (set by your system)",
    motionHint: "Lite turns off bouncing, tilt and confetti. It is on automatically when your system asks for reduced motion.",
  },
  id: {
    appName: "EduCentre",
    appSubtitle: "Manajemen Bimbel",
    login: "Masuk",
    email: "Email",
    password: "Kata Sandi",
    signIn: "Masuk",
    signingIn: "Sedang masuk…",
    welcomeBack: "Selamat datang kembali",
    loginSubtitle: "Kelola bimbel Anda dengan jelas. Masuk untuk melanjutkan.",
    logout: "Keluar",
    dashboard: "Dasbor",
    students: "Siswa",
    educators: "Pengajar",
    parents: "Orang Tua",
    classes: "Kelas",
    schedule: "Jadwal",
    enrollment: "Pendaftaran",
    attendance: "Kehadiran",
    markAttendance: "Catat Kehadiran",
    grades: "Nilai",
    enterGrades: "Masukkan Nilai",
    results: "Hasil",
    materials: "Materi",
    invoices: "Tagihan",
    fees: "Biaya & Pembayaran",
    announcements: "Pengumuman",
    reports: "Laporan",
    settings: "Pengaturan",
    myDashboard: "Dasbor Saya",
    myClasses: "Kelas Saya",
    mySchedule: "Jadwal Saya",
    myResults: "Hasil Saya",
    myFees: "Biaya Saya",
    myChildren: "Anak Saya",
    overview: "Ikhtisar",
    people: "Orang",
    academics: "Akademik",
    finance: "Keuangan",
    system: "Sistem",
    addStudent: "Tambah Siswa",
    addEducator: "Tambah Pengajar",
    addClass: "Tambah Kelas",
    save: "Simpan",
    cancel: "Batal",
    back: "Kembali",
    next: "Berikutnya",
    confirm: "Konfirmasi",
    search: "Cari",
    activeStudents: "Siswa Aktif",
    activeClasses: "Kelas Aktif",
    activeEducators: "Pengajar Aktif",
    revenueThisMonth: "Pendapatan Bulan Ini",
    outstandingFees: "Tagihan Belum Bayar",
    overdueInvoices: "Tagihan Terlambat",
    todaysClasses: "Kelas Hari Ini",
    pendingTasks: "Tugas Tertunda",
    attendanceRate: "Tingkat Kehadiran",
    role_admin: "Manajemen",
    role_educator: "Pengajar",
    role_student: "Siswa",
    role_parent: "Orang Tua",
    name: "Nama",
    code: "Kode",
    actions: "Aksi",
    status: "Status",
    statusActive: "Aktif",
    statusInactive: "Tidak Aktif",
    statusPaid: "Lunas",
    statusUnpaid: "Belum Bayar",
    statusOverdue: "Terlambat",
    statusPartial: "Sebagian",
    statusPresent: "Hadir",
    statusLate: "Terlambat",
    statusAbsent: "Tidak Hadir",
    statusExcused: "Diizinkan",
    payNow: "Tandai Lunas",
    invoice: "Tagihan",
    amount: "Jumlah",
    dueDate: "Jatuh Tempo",
    description: "Keterangan",
    student: "Siswa",
    educator: "Pengajar",
    subject: "Mata Pelajaran",
    level: "Tingkat",
    room: "Ruangan",
    capacity: "Kapasitas",
    fee: "Biaya",
    schedule_days: "Hari",
    time: "Waktu",
    enrolled: "Terdaftar",
    enroll: "Daftarkan",
    selectStudent: "Pilih siswa",
    selectClass: "Pilih kelas",
    new: "Baru",
    title: "Judul",
    body: "Isi",
    audience: "Audiens",
    post: "Kirim",
    materialTitle: "Judul Materi",
    materialUrl: "URL / Tautan",
    upload: "Unggah",
    addMaterial: "Tambah Materi",
    assessmentName: "Nama Penilaian",
    maxScore: "Nilai Maksimal",
    publish: "Publikasikan",
    unpublished: "Belum Dipublikasikan",
    published: "Dipublikasikan",
    score: "Nilai",
    remark: "Catatan",
    saveAll: "Simpan Semua",
    submit: "Kirim",
    welcome: "Selamat datang",
    today: "Hari Ini",
    days: { 1: "Sen", 2: "Sel", 3: "Rab", 4: "Kam", 5: "Jum", 6: "Sab", 7: "Min" },
    daysLong: { 1: "Senin", 2: "Selasa", 3: "Rabu", 4: "Kamis", 5: "Jumat", 6: "Sabtu", 7: "Minggu" },
    months: { 1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mei", 6: "Jun", 7: "Jul", 8: "Agu", 9: "Sep", 10: "Okt", 11: "Nov", 12: "Des" },
    children: "Anak",
    noClasses: "Tidak ada kelas hari ini.",
    noData: "Belum ada data.",
    emptyHint: "Belum ada isi di sini. Data baru akan muncul di sini.",
    loadFailed: "Halaman tidak bisa dimuat",
    loadFailedHint: "Periksa koneksi internet Anda, lalu coba lagi.",
    retry: "Coba lagi",
    edit: "Ubah",
    delete: "Hapus",
    deactivate: "Nonaktifkan",
    reactivate: "Aktifkan kembali",
    previous: "Sebelumnya",
    showing: "Menampilkan",
    of: "dari",
    noResults: "Tidak ada hasil",
    noResultsHint: "Coba kata kunci lain atau hapus filter.",
    clearFilters: "Hapus filter",
    allStatuses: "Semua status",
    saved: "Perubahan disimpan",
    removed: "Berhasil dihapus",
    deleteTitle: "Hapus data ini?",
    deleteHint: "Tindakan ini tidak bisa dibatalkan.",
    deactivateTitle: "Nonaktifkan orang ini?",
    deactivateHint: "Mereka tidak bisa masuk lagi. Riwayatnya tetap tersimpan dan bisa diaktifkan kembali nanti.",
    importStudents: "Impor",
    importTitle: "Impor siswa dari file",
    importHint: "Gunakan file CSV (di Excel pilih Save As → CSV). Kolom wajib: full_name, email. Opsional: phone, dob, school_name, school_year.",
    downloadTemplate: "Unduh templat",
    chooseFile: "Pilih file CSV",
    importPreview: "baris ditemukan",
    importNow: "Impor siswa",
    importDone: "siswa berhasil diimpor",
    importSkipped: "dilewati",
    importDefaultPassword: "Siswa baru masuk dengan kata sandi bawaan student123.",
    notifTitle: "Notifikasi",
    notifEmpty: "Semua sudah beres.",
    notifMarkAllRead: "Tandai semua dibaca",
    notifOverdue: "Tagihan {invoice} untuk {name} sudah lewat jatuh tempo: {amount} belum dibayar (jatuh tempo {date}).",
    notifDueSoon: "Tagihan {invoice} untuk {name} jatuh tempo pada {date}: {amount}.",
    notifAbsent: "{name} tidak hadir pada {date}.",
    notifClassesToday: "Anda punya {count} kelas hari ini.",
    sendWhatsapp: "Kirim pengingat WhatsApp",
    waReminder: "Halo, ini pengingat dari {centre}: tagihan {invoice} untuk {name} ({amount}) jatuh tempo pada {date}. Mohon segera diselesaikan. Terima kasih.",
    printSave: "Cetak / Simpan sebagai PDF",
    printInvoice: "Cetak tagihan",
    printReceipt: "Kuitansi",
    invoiceHeading: "TAGIHAN",
    receiptHeading: "KUITANSI PEMBAYARAN",
    billedTo: "Ditagihkan kepada",
    amountPaid: "Jumlah dibayar",
    balanceDue: "Sisa tagihan",
    paidOn: "Dibayar pada",
    paymentHistory: "Riwayat pembayaran",
    thankYou: "Terima kasih atas pembayaran Anda.",
    printFooter: "Dokumen ini dibuat oleh EduCentre.",
    reportCard: "Rapor",
    reportCardHeading: "RAPOR SISWA",
    attendanceSummary: "Ringkasan kehadiran",
    averageScore: "Nilai rata-rata",
    generatedOn: "Dibuat pada",
    exportCsv: "Ekspor CSV",
    settingsTitle: "Pengaturan",
    settingsSubtitle: "Profil, kata sandi, dan data lembaga Anda",
    profile: "Profil",
    centreDetails: "Data lembaga",
    centreName: "Nama lembaga",
    centreHint: "Ditampilkan pada tagihan, kuitansi, dan rapor yang dicetak.",
    address: "Alamat",
    changePassword: "Ganti kata sandi",
    currentPassword: "Kata sandi saat ini",
    newPassword: "Kata sandi baru",
    confirmPassword: "Ulangi kata sandi baru",
    passwordMismatch: "Kedua kata sandi baru tidak sama.",
    passwordChanged: "Kata sandi diganti",
    profileSaved: "Profil disimpan",
    uploadFile: "Unggah file",
    chooseAFile: "Pilih file (maks. 5 MB)",
    downloadFile: "Unduh",
    toastStudentAdded: "Siswa ditambahkan",
    toastEducatorAdded: "Pengajar ditambahkan",
    toastParentAdded: "Orang tua ditambahkan",
    toastClassCreated: "Kelas dibuat",
    toastAnnouncementPosted: "Pengumuman diposting",
    toastMaterialAdded: "Materi ditambahkan",
    toastInvoiceCreated: "Tagihan dibuat",
    toastPaymentRecorded: "Pembayaran dicatat",
    toastAttendanceSaved: "Kehadiran disimpan",
    toastEnrollmentConfirmed: "Pendaftaran dikonfirmasi",
    toastAssessmentCreated: "Penilaian dibuat",
    toastGradesSaved: "Nilai disimpan",
    toastPublished: "Dipublikasikan",
    fieldType: "Jenis",
    subjectsComma: "Mata pelajaran (pisahkan dengan koma)",
    qualifications: "Kualifikasi",
    occupation: "Pekerjaan",
    colorLabel: "Warna",
    startTime: "Mulai",
    endTime: "Selesai",
    selectPlaceholder: "— Pilih —",
    nonePlaceholder: "— Tidak ada —",
    amountIdr: "Jumlah (IDR)",
    gradeLabel: "Nilai huruf",
    assessmentLabel: "Penilaian",
    newAssessment: "Penilaian Baru",
    passScore: "Nilai Lulus",
    typeQuiz: "Kuis",
    typeTest: "Ujian",
    typeAssignment: "Tugas",
    typeProject: "Proyek",
    audAll: "Semua",
    audParents: "Orang tua",
    audStudents: "Siswa",
    audEducators: "Pengajar",
    audClass: "Kelas",
    matLink: "Tautan",
    matFile: "Berkas",
    matVideo: "Video",
    emp_full_time: "Penuh waktu",
    emp_part_time: "Paruh waktu",
    emp_freelance: "Lepas",
    emp_contract: "Kontrak",
    rpTotalStudents: "Total Siswa",
    rpTotalClasses: "Total Kelas",
    rpTotalInvoices: "Total Tagihan",
    rpPaidInvoices: "Tagihan Lunas",
    rpTotalRevenue: "Total Pendapatan",
    rpClassUtilisation: "Utilisasi Kelas",
    rpInvoiceStatus: "Rincian Status Tagihan",
    rpTopClasses: "Kelas Biaya Tertinggi",
    rpQuickStats: "Statistik Cepat",
    rpSubtitle: "Ringkasan bisnis dan operasional",
    unitPosts: "pengumuman",
    unitResources: "materi",
    unitInvoices: "tagihan",
    subManage: "Kelola penilaian dan nilai",
    subViewResults: "Lihat hasil",
    subPublished: "Hanya penilaian yang dipublikasikan",
    subWizard: "Panduan 4 langkah",
    openLink: "Buka →",
    loadingLabel: "Memuat",
    openNav: "Buka navigasi",
    navMore: "Lainnya",
    navMain: "Navigasi utama",
    closeNav: "Tutup navigasi",
    developedBy: "Dikembangkan oleh",
    refLabel: "Referensi",
    themeToggle: "Ganti mode gelap",
    themeLight: "Mode terang",
    close: "Tutup",
    skipToContent: "Lompat ke konten",
    newInvoice: "Tagihan baru",
    addParent: "Tambah orang tua",
    amountsLocked: "Jumlah tidak bisa diubah setelah ada pembayaran.",
    themeDark: "Mode gelap",
    fullName: "Nama Lengkap",
    phone: "Telepon",
    selectRole: "Peran",
    invalidLogin: "Email atau kata sandi salah",
    monthlyTuition: "Tuition Bulanan",
    selectedCourses: "Kursus Dipilih",
    totalPerMonth: "Total Per Bulan",
    studentInfo: "Info Siswa",
    selectCourses: "Pilih Kursus",
    feePlan: "Rencana Biaya",
    confirmStep: "Konfirmasi",
    timetable: "Jadwal Mingguan",
    weekDays: ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"],
    paymentMethod: "Metode Pembayaran",
    cash: "Tunai",
    bank: "Transfer Bank",
    qris: "QRIS",
    ewallet: "Dompet Digital",
    record: "Catat",
    invoiceNumber: "No. Tagihan",
    billingMonth: "Bulan Tagihan",
    yearLevel: "Tingkat Tahun",
    school: "Sekolah",
    dob: "Tanggal Lahir",
    parent: "Orang Tua",
    childrenLinked: "Anak Terhubung",
    rolePill: "Melihat sebagai",
    quickStats: "Statistik Cepat",
    cmdOpen: "Cari atau pindah ke…",
    cmdPlaceholder: "Ketik halaman, aksi, atau nama siswa…",
    cmdTitle: "Palet perintah",
    cmdEmpty: "Tidak ada hasil.",
    cmdPages: "Pindah halaman",
    cmdActions: "Aksi cepat",
    cmdStudents: "Siswa",
    cmdOpenReport: "Rapor",
    cmdSwitchLang: "Ganti ke English",
    cmdToggleMotion: "Ganti gerak (Penuh / Hemat)",
    motionLabel: "Gerak",
    motionFull: "Penuh",
    motionLite: "Hemat",
    motionSystemLite: "Hemat (diatur oleh sistem Anda)",
    motionHint: "Mode Hemat mematikan pantulan, kemiringan kartu, dan konfeti. Otomatis aktif bila sistem Anda meminta gerak dikurangi.",
  },
};

const LangContext = createContext({ lang: "en", setLang: () => {}, t: DICT.en });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ec_lang") || "en");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("ec_lang", l);
  };
  const t = DICT[lang] || DICT.en;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
